<template>
  <v-container class="fondo_login fill-height" fluid>
    <Loader :esActiva="loader_login"/>
    <v-row class="d-flex justify-center">       
      <v-col sm=12 md="6" xs="12">
        <v-img 
          :src="vista.url_img"
          height="70"
          width="280"
          class="centrify "
        >
        </v-img>                 
        <div class="d-flex justify-center" id="google_btn"></div>         
        <div class="v-btn-signin" :style="{ 'width': `${ancho_boton}px`}">
          <fb-signin-button
            class="signin-button f-signin-button"
            :params="fbSignInParams"
            @success="onSignInSuccess_fb"
            @error="onSignInError_fb"
          >      
            <v-icon
              depressed
              class="mr-2"
              right
              color="#1877f2"
            >
              mdi-facebook
            </v-icon>                
            Iniciar sesión con Facebook
          </fb-signin-button>
        </div>
      </v-col>     
    <hr class="divisor-medio my-2">   
    </v-row>   
    <v-row class="d-flex justify-center">
      <v-col sm=12 md=6 >
        <v-form class="d-flex align-center flex-column" v-model="valido" ref="form">
          <v-text-field
            dense
            v-model="usuario.correo"
            label="Correo electrónico"
            onkeypress="return event.charCode != 32"
            placeholder="Correo electrónico"
            prepend-inner-icon="mdi-email-outline"
            :rules="[v => !!v || 'El correo electrónico es obligatorio', rules.email]"
            :style="{ 'width': `${ancho_boton}px`}"
            solo
          ></v-text-field>
          <v-text-field
            dense
            v-model="usuario.password"
            label="Contraseña"
            type="password"
            placeholder="Contraseña"
            prepend-inner-icon="mdi-lock-outline"
            :rules="[v => !!v || 'La contraseña es obligatoria', rules.password]"
            :style="{ 'width': `${ancho_boton}px`}"
            solo
          ></v-text-field>        
          <div 
              class="btn-registrate pb-3 subtitle-1 text-center"
              @click="$router.push('/recuperar')"
              style="margin-top:-10px"
            > ¿Olvidaste tu contraseña?</div>            
          <v-btn class="mb-3 white--text"
            :style="{ 'width': `${ancho_boton}px`, 'height': '40px' }" 
            color="#58C4B5" :disabled="!valido"
            @click.stop="login"  >         
            inicia sesión
          </v-btn>                      
          </v-form>
      </v-col> 
      <hr class="divisor"> 
      <!-- version 1 -->
      <!--<div class="mr-2 blue-grey--text subtitle-1 pt-5 text-center" style="margin-top:-10px;">
        ¿No tienes una cuenta? <a @click="$router.push('/opciones_registro')" style="font-size:19px;">Regístrate</a><br>             
      <a style="padding-left: 16px; font-size:13px;" @click="ver_version()">Versión {{version}}</a>
      </div>-->

      <!-- version 2 -->
     <!-- <div class="mr-2 blue-grey--text subtitle-1 pt-5 text-center" style="margin-top:-10px;">
        ¿No tienes una cuenta?
      </div>    
    </v-row>
    <v-row class="d-flex justify-center mt-0">
      <v-col  cols=4 style="max-width:200px;">          
        <v-btn 
          block  
          class="py-7  white--text" 
          color="#58C4B5" 
          @click="$router.push('/opciones_registro')">         
          Regístrate
        </v-btn>
      </v-col>
    </v-row>
    <v-row class="d-flex justify-center">
      <div class="mr-2 blue-grey--text subtitle-1 text-center">
        <a style="padding-left: 16px; font-size:13px;" @click="ver_version()">Versión {{version}}</a>
      </div> -->

      <!-- version 3 -->
      <div class="blue-grey--text subtitle-1 pt-5 text-center" style="margin-top:-15px;">
        ¿No tienes una cuenta? <v-btn class="white--text" style="margin-left:30px; height: 40px;" color="#58C4B5" @click="$router.push('/opciones_registro')">Regístrate</v-btn><br>             
        <a style="padding-left: 16px; font-size:13px;" @click="ver_version()">Versión {{version}}</a>
        <div v-if="usuario.direccion_soporte" class="d-flex justify-end mt-2">
          <a :href="usuario.direccion_soporte" target="_blank" class="estilo_click mr-1">¿Necesitas Ayuda?</a><v-icon color="green">mdi-whatsapp</v-icon>
        </div>
      </div>
    </v-row>   
    <!-- <v-row class="d-flex justify-center">
      <div class="mr-1 blue-grey--text subtitle-1 pt-1">
          <a @click="ver_version()" style="font-size:13px;">Versión {{version}}</a><br>
          <a @click="ver_aviso()" style="font-size:13px;">Aviso de privacidad</a>
      </div>       
    </v-row> -->
    <ModalVersion
        :esActiva="modal_version"
        :version="version"
        @respuesta_modal_cancelar ="(valor) => {modal_version = false;}
      "
    />
    <ModalAvisoPrivacidad
    :activarModal="modal_aviso_privacidad"    
    :ventana="estilo_ventana"
    @modal_cancelar ="(valor) => {modal_aviso_privacidad = false;}" />       
  </v-container>  
</template>

<script>
import Conexion_api from "@/api/Conexion_api.js";
import Vista from "@/objetos/vista";
import Usuario from "@/objetos/usuario";
import Loader from '@/components/Loader/Loader.vue';
import ModalVersion from '@/components/LoginGeneral/ModalVersion.vue'
import ModalAvisoPrivacidad from '@/components/LoginGeneral/ModalAvisoPrivacidad.vue'
import jwt_decode from 'jwt-decode'
import process_env from '@/config/dev.env.js'


/**
 * Esta funcion carga asincronamente el SDK de FB en la app.
 * Fuente: https://developers.facebook.com/docs/facebook-login/web
 * 4228201323886088 - QA
 * 1916541518553574 - Prod
 */
window.fbAsyncInit = function () {
  // eslint-disable-next-line no-undef
  FB.init({
    appId: "1916541518553574", 
    cookie: true, // enable cookies to allow the server to access the session
    xfbml: true, // parse social plugins on this page
    version: "v2.8" // use graph api version 2.8
  });
};
(function (d, s, id) {
  var js,
    fjs = d.getElementsByTagName(s)[0];
  if (d.getElementById(id)) return;
  js = d.createElement(s);
  js.id = id;
  js.src = "//connect.facebook.net/en_US/sdk.js";
  fjs.parentNode.insertBefore(js, fjs);
})(document, "script", "facebook-jssdk");

export default {
  data: () => ({
    mostrar_error: false,
    mensaje_error: null,
    version: "2.3.3",
    modal_version: false,
    modal_aviso_privacidad: false,
    estilo_ventana: 'letra',
    rules: {
      email: value => {
        if(!value) return true 
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return pattern.test(value) || 'Email invalido.'
      },
      password: value => {
        if(!value) return true 
        const pattern = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z!@#\\$%\\^&\\*\d]{8,}$/
        return pattern.test(value) || 'La contraseña debe contener 8 carácteres,1 mayúscula 1 número'        
      }                 
    },
    vista: Vista,
    /*
      Se declaran los parametros que se pretenden que regrese la API
       de facebook en caso de logeo existoso
    */
    fbSignInParams: {
      scope: "email, public_profile",
      return_scopes: true
    },
    mostrar: false,
    modal_registrarse: false,
    pagina: null,
    registrarse: 'registrarse',
    loader: null,
    loader_login: false,
    valido: false,
    usuario:Usuario,
    process_env: process_env    
  }),
  components: {
    Loader,
    ModalVersion,
    ModalAvisoPrivacidad
  },    
  watch: {
    $route(to) {
      this.pagina = to.name;
    },
    loader() {
      const l = this.loader
      this[l] = !this[l]

      setTimeout(() => (this[l] = false), 3000)

      this.loader = null
    },
  },
  computed: {
    opacidad: function () {
      if (this.valido) {
        return 1;
      }
      return 0.9;
    },
    ancho_boton () {
      let ancho;
        switch (this.$vuetify.breakpoint.name) {
          case 'xs':
            if(this.$vuetify.breakpoint.width < 340) ancho = '250'
            else ancho = '300'
          break;
          case 'sm': ancho ='400'
          break;
          case 'md': ancho = '400'
          break
          case 'lg': ancho = '400'
          break;
          case 'xl': ancho = '400'
          break;
        }
      return ancho
    }
  },
  created(){
    console.log("ID")          
      Usuario.google = window.google
      Usuario.google.accounts.id.initialize({
        client_id: this.process_env.CLIENT_ID,
        callback: this.handleCredentialResponse,
        itp_support: false      
      });         
      
  },
  mounted() {
    this.vista.nombre = "/home";
    //El script de google se cargo a public https://accounts.google.com/gsi/client
    /**
     * The Auth2 parameters, as seen on
     * En esta sección se declara el client id que da google solo se debe de cargar una vez 
     * ya que esta nueva versiòn google no permite cargarlo dos veces 
     * https://developers.google.com/identity/gsi/web/reference/js-reference?hl=es-419
     * As the very least, a valid client_id must present.
     * @type {Object}
     */
    Usuario.correo = "";
    Usuario.password = "";       
    const parent = document.getElementById('google_btn');                            
    Usuario.google.accounts.id.renderButton(parent, {locale:"es",logo_alignment:"center",size:"large",text: "signin_with", width: this.ancho_boton ? Number(this.ancho_boton) : 400});
    this.$root.$off('enviar_datos');
    Usuario.codigo_valido = false;      
  },
  methods: {
    login() {
      this.loader_login = true
      this.mostrar_error = false;
      Conexion_api({
          body: {
            ...this.usuario            
          },
          evento: "login/login_pedidos"
        })
        .then(respuesta => {    
          this.loader_login = false
          if (respuesta.data.error) {        
            this.$root.$emit('snackbar',{ color:"error", texto: respuesta.data.error})   
            Usuario.correo = null
            Usuario.password = ""
            Usuario.login_social = false      
            return;            
          }
          if(!respuesta.data.usuario.confirmado){
            this.$root.$emit('snackbar', { color:"error", texto: "No ha confirmado su cuenta."})   
            this.$router.push("/recuperar")
            return
          }
          Usuario.coordenadas = respuesta.data.usuario.coordenadas
          Usuario.nombre = respuesta.data.usuario.nombre
          Usuario.nombre_vista = respuesta.data.usuario.nombre
          Usuario.direccion = respuesta.data.usuario.direccion
          Usuario.rut = respuesta.data.usuario.rut
          this.$cookie.set('pwst', respuesta.data.token, { expires: '1h' });
           var DBDeleteRequest = window.indexedDB.deleteDatabase("pushDb");
          //console.log("eliminar base login")
          DBDeleteRequest.onerror = function() {
            //console.log("Error deleting database.");
          };

          DBDeleteRequest.onsuccess = function(event) {
            //console.log("Database deleted successfully");

            console.log(event.result); // should be undefined
          };                                    
          this.$router.push("/distribuidor")
        })
        .catch(err => {
          this.loader_login = false
          err = String(err);
          this.$root.$emit('snackbar',{ color:"error", texto: err}) 
          Usuario.correo = null
          Usuario.password = ""
          Usuario.login_social = false                
          console.error(err);
        });
    },
      /**Google
     * Está función se manda a llamar cuando se ha logeado a google con éxito.
     * Fuente: https://developers.google.com/identity/sign-in/web/reference#users
    */
    onSignInSuccess(googleUser) {
      // `googleUser` is the GoogleUser object that represents the just-signed-in user.      
      const profile = googleUser.getBasicProfile(); // etc etc
      Usuario.correo = profile.getEmail();
      Usuario.login_social = true
      if(Usuario.correo){
        this.login()
      }      
    },
    handleCredentialResponse(response){
      const responsePayload = jwt_decode(response.credential);
        Usuario.correo = responsePayload.email;
        Usuario.login_social = true
        if(Usuario.correo){
          this.login()
        }
    },
    /**Facebook
     * Está función se manda a llamar cuando a habido error al logearse 
    */    
    onSignInError(error) {
      // `error` contains any error occurred.
      console.error("onSignInErrorGoogle", error);
    },
    /**Facebook
     * Está función se manda a llamar cuando se ha logeado a FB con éxito
    */
    onSignInSuccess_fb(response) {
      // Tomar de aqui el tiempo de sesion response.data_access_expiration_time: 1601845791
      // response.expiresIn: 5107217
      // eslint-disable-next-line no-undef
      FB.api("/me", {
        fields: "name, last_name,  email, location, public_key, permissions"
      }, facebookUser => {
        if (response.status == "connected") {          
          Usuario.correo = facebookUser.email;
          Usuario.login_social = true 
          if(Usuario.correo) this.login()
        }
      });
    },
    onSignInError_fb(error) {
      console.error("onSignInError_fb: ", error);
    },
    cambiar_vista(nombre) {
      let ruta = `/${nombre.toLowerCase()}`
      if (this.pagina != nombre)
        this.$router.push(ruta)
    },
    ver_version(){
      this.modal_version = true;
    },
    ver_aviso(){
        this.modal_aviso_privacidad = true
    }
  }
};
</script>

<style scoped>
.fondo_login{
  background: #F5F5F5 0% 0% no-repeat padding-box;
  background-size: 100% 100% !important;
  align-content: center;
}

.v-btn-signin{
  display: flex;
  align-items: center;
  margin: 0 auto;
  border-radius: 4px;
  border: 1px solid #dadce0 !important;
  text-transform: none;
  height: 40px !important;
  padding: 0 !important;
  letter-spacing: 0.25px;
  background: #ffffff;
  font-weight: 600;
  text-align: center;
  cursor: pointer;
  font-family: "Google Sans",arial,sans-serif;
  color: #0e0a0aa3;
  font-size: 13px;
}

.v-btn-signin:hover {
  background: rgba(70, 137, 243, 0.1);
  border: 1px solid rgb(66,133,244, 0.2) !important;
}

.signin-button{
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 40px;
}
</style>